/**
 * Чипы значений для выпадающих списков.
 *
 * В ячейке значение справочника показано цветным чипом — «TOP-1» зелёный,
 * «TOP-3» жёлтый. В открытом списке до сих пор стоял обычный текст, и цвет
 * появлялся только после выбора: выбирать приходилось вслепую. Здесь к каждой
 * строке списка добавляется ровно тот чип, который окажется в ячейке.
 */
import type { EnumValue } from '@shared/types.ts'
import type { SelectOption } from '../../../components/index.js'
import { TierBadge, chipColor } from '../../../components/index.js'
import { enumColor } from './values.js'

/** Один чип: тир — своим бейджем, остальные наборы — цветной плашкой. */
export function enumBadge(
  setCode: string | undefined, value: string, label: string, color?: string | null,
) {
  if (!setCode) return undefined
  if (setCode === 'tier') return <TierBadge tier={value} />
  return (
    <span className="enum-chip" data-set={setCode} data-value={value} data-color={chipColor(color)}>
      {label}
    </span>
  )
}

/** Те же опции, но с чипом в каждой строке. */
export function withEnumBadges(
  options: SelectOption[],
  setCode: string | undefined,
  enums?: Record<string, EnumValue[]>,
): SelectOption[] {
  if (!setCode) return options
  return options.map((option) => {
    const color = enums ? enumColor(enums, setCode, option.value) : null
    const badge = enumBadge(setCode, option.value, option.label, color)
    return badge ? { ...option, badge } : option
  })
}
